import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

const ArsenalLogo = ({ sx, ...props }) => {
  const { t } = useTranslation();
  return (
    <Box
      component="img"
      src="/logo.png"
      alt={t('hardcoded.components_common_arsenallogo.arsenal_logo')}
      sx={{
        display: 'block',
        height: 25,
        width: 'auto',
        objectFit: 'contain',
        ...sx, // permite override desde afuera
      }}
      {...props}
    />
  );
};

export default ArsenalLogo;
